(function () {

  let main = {}

  // Clone dropdown

  const tooltipTriggerEl = document.querySelector('#copyButton')
  if (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl, {trigger: 'manual'})
  }

  main.copyToClipboard = function (event) {
    const input = document.querySelector('.form-control');
    input.select();
    document.execCommand('copy');

    // Show tooltip
    const copyButton = document.getElementById('copyButton');
    const tooltip = bootstrap.Tooltip.getInstance(copyButton);
    tooltip.show();

    // Hide tooltip after 1.5 seconds
    setTimeout(() => {
        tooltip.hide();
    }, 1500);
  }

  main.copyTextToClipboard = function (text, buttonEl) {
    const textarea = document.createElement('textarea');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    if (buttonEl) {
      const tooltip = bootstrap.Tooltip.getOrCreateInstance(buttonEl, {trigger: 'manual'});
      tooltip.show();
      setTimeout(() => tooltip.hide(), 1500);
    }
  }

  // end clone dropdown

  var fsetTmpl
  var newNum = 0

  main.initFieldList = function (el) {
    initCollapseAll(el)
    if (! _.config.ENABLE_JS_LIST) {
      return
    }
    // For AJAX mode, we don't need to clone templates anymore
    // The subforms will be fetched from the server on demand
    // Just initialize with any existing fields
  }

  main.listFieldAdd = function (el) {
    console.log('[listFieldAdd] Called with element:', el)

    if (! _.config.ENABLE_JS_LIST) {
      console.log('[listFieldAdd] Non-AJAX mode, using hidden fields')
      var $item
      $item = $(el).parent().find('fieldset.d-none').first()
      $item.removeClass('d-none')
      $item.find('[id$=disabled]').remove()
      return
    }

    console.log('[listFieldAdd] AJAX mode enabled')

    // Get field list metadata from the fieldset element
    const fieldset = $(el).closest('fieldset[data-field-name]')
    console.log('[listFieldAdd] Found fieldset:', fieldset[0])

    // Find the .fset-container that's a sibling (previous element) of this button
    // The button is after the container in the DOM structure
    const fsetContainer = $(el).prevAll('.fset-container').first()
    console.log('[listFieldAdd] Found container:', fsetContainer[0])

    // Extract site, collection, and doc name from the page URL
    // Format: /sites/doc/{site_name}/{coll_name}/edit/{doc_name} or /sites/doc/{site_name}/{coll_name}/new
    const pathParts = window.location.pathname.split('/')
    const siteName = pathParts[3]  // site_name
    const collName = pathParts[4]  // coll_name
    // pathParts[5] is 'edit', 'delete', or 'new'
    let docName = ''
    if (pathParts[5] === 'edit' || pathParts[5] === 'delete') {
      docName = pathParts.slice(6).join('/')  // doc_name (may have slashes)
    }
    console.log('[listFieldAdd] Site:', siteName, 'Collection:', collName, 'Doc:', docName)

    // Get field name and short name from data attributes
    const fieldName = fieldset.data('field-name')
    const fieldShortName = fieldset.data('field-short-name')
    console.log('[listFieldAdd] Field name:', fieldName)
    console.log('[listFieldAdd] Field short name:', fieldShortName)

    if (!fieldName) {
      console.error('[listFieldAdd] Field name not found on fieldset')
      console.error('[listFieldAdd] Fieldset attributes:', fieldset[0].attributes)
      alert('Unable to add new item. Field name is missing.')
      return
    }

    // Calculate the next index based on existing subforms
    // Use children() to get only direct child fieldsets (not nested ones)
    const existingFields = fsetContainer.children('fieldset.list-field')
    console.log('[listFieldAdd] Existing fields count:', existingFields.length)
    const nextIndex = existingFields.length

    // Build the request payload
    const payload = {
      index: nextIndex,
      field_short_name: fieldShortName || fieldName,
      parent_field_name: fieldName,
      doc_name: docName  // For DecapFileCollection
    }
    console.log('[listFieldAdd] Request payload:', payload)

    // Make AJAX request to get the HTML for the new subform
    // Use fieldName as the path, which includes parent indices for nested fields
    const url = `/sites/api/render-subform/${siteName}/${collName}/${fieldName}`
    console.log('[listFieldAdd] Fetching from URL:', url)

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log('[listFieldAdd] Response status:', response.status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      console.log('[listFieldAdd] Response data:', data)
      if (data.html) {
        console.log('[listFieldAdd] Appending HTML to container')
        // Append the new subform HTML
        fsetContainer.append(data.html)
        console.log('[listFieldAdd] HTML appended successfully')

        // Get the newly added fieldset (no special handling needed)
        console.log('[listFieldAdd] Subform added and ready for input')

        // Re-initialize sortable if needed
        const sortableEl = fsetContainer[0]
        if (sortableEl && typeof Sortable !== 'undefined') {
          console.log('[listFieldAdd] Re-initializing Sortable')
          new Sortable(sortableEl, {animation: 150, handle: '.js-sortable-handle'})
        }
      } else if (data.error) {
        console.error('[listFieldAdd] Server returned error:', data.error)
        alert('Failed to add new item: ' + data.error)
      } else {
        console.error('[listFieldAdd] Unexpected response format:', data)
        alert('Failed to add new item. Unexpected response format.')
      }
    })
    .catch(error => {
      console.error('[listFieldAdd] Fetch error:', error)
      console.error('[listFieldAdd] Error stack:', error.stack)
      alert('Failed to add new item: ' + error.message)
    })
  }

  main.listFieldRemove = function (el) {
    _.rollupRemove($(el).closest('.list-field')[0])
  }

  main.onUploadClick = function (data, refs) {
    var file_id = data.field_id + "-file"
    var file_input = `<input id="${file_id}" x-on:change="main.onFileChange($data, $refs)" type="file" />`
    refs.hidden.insertAdjacentHTML('beforeend', file_input)
    document.getElementById(file_id).click()
  }

  main.onFileChange = function (data, refs) {
    var file_input, file, upload_url

    function setProgress(progress) {
      $(refs.progressBar).css('width', progress + '%')
    }

    function setAttributes(attributes) {
      $(refs.url_input).val(attributes.href)
      $(refs.progressBar).addClass('d-none')
    }

    $(refs.progressBar).removeClass('d-none')
    upload_url = data.upload_url
    file_input = $(refs.hidden).find('input')[0]
    if (file_input.files) {
      file = file_input.files[0]
      uploadFile(file, upload_url, setProgress, setAttributes)
    }
  }

  function uploadFile (file, upload_url, progressCallback, successCallback) {
    const params = {
      name: file.name,
      type: file.type
    }
    fetch(_.appendQueryArgs(upload_url, params))
      .then(response => response.json()
        .then(formobj => postToBucket(file, formobj, progressCallback, successCallback)))
  }
  main.uploadFile = uploadFile

  function postToBucket(file, formobj, progressCallback, successCallback) {
    var formData = createFormData(file, formobj.fields)
    var xhr = new XMLHttpRequest()

    xhr.open("POST", formobj.url, true)

    xhr.upload.addEventListener("progress", function(event) {
      var progress = event.loaded / event.total * 100
      progressCallback(progress)
    })

    xhr.addEventListener("load", function(event) {
      var download_url, attributes

      if (xhr.status == 204) {
        // proxy_url must be provided by the server
        if (!formobj.proxy_url) {
          console.error("Server error: proxy_url not provided in upload response")
          return
        }
        download_url = formobj.proxy_url
      }
      attributes = {
        url: download_url,
        href: download_url,
        name: false,
        size: false
      }
      successCallback(attributes)
    })

    xhr.send(formData)
  }

  function createFormData(file, fields) {
    var data = new FormData()
    for (const [key, value] of Object.entries(fields)) {
      data.append(key, value)
    }
    data.append("file", file)
    return data
  }

  function initSortable() {
    document.querySelectorAll(".js-sortable").forEach(el => {
      new Sortable(el, {animation: 150, handle: '.js-sortable-handle'})
    })
  }

  function initCollapseAll(parent) {

    const collapseBtn = parent.querySelector(".js-collapse-all")
    collapseBtn.addEventListener('click', () => {
      parent.querySelectorAll('.collapse').forEach(el => {
        const collapse = bootstrap.Collapse.getOrCreateInstance(el)
        collapse.hide()
      })
    })
    const expandBtn = parent.querySelector(".js-expand-all")
    expandBtn.addEventListener('click', () => {
      parent.querySelectorAll('.collapse').forEach(el => {
        const collapse = bootstrap.Collapse.getOrCreateInstance(el)
        collapse.show()
      })
    })

    document.querySelectorAll(".js-card-title").forEach(elTitle => {
      const elInput = elTitle.closest(".card").querySelector('input[type="text"]')
      if (elInput) {
        elTitle.textContent = elInput.value
        elInput.addEventListener('input', () => {
          elTitle.textContent = elInput.value
        })
      }
    })

  }

  main.initTooltip = function (el) {
    new bootstrap.Tooltip(el)
  }

  document.addEventListener("DOMContentLoaded", function () {
    initSortable()
    const elInitList = document.querySelectorAll('[data-init]')
    elInitList.forEach(el => {
      const fn = main[el.dataset.init]
      fn(el)
    });
  })

  jQuery.noConflict()
  jQuery(document).ready(function ($) {
    $('[data-jqinit=summernote]').each(function() {
      let $el = $(this)

      function onImageUpload (files) {
        attachments.handleSummerUpload(files, $el)
      }

      let summerConfig = {
        lang: 'en-US',
        callbacks: {
          onImageUpload: onImageUpload
        }
      }
      $el.summernote(summerConfig)
    })
  })

  addEventListener("trix-attachment-add", attachments.handleTrixUpload)

  window.main = main

})();
